<template>
  <div>
    <div class="overlay"></div>
    <div class="modal_fixed">
      <div class="bonus_phase_box midnight_bonus modal_cont" id="">
        <img src="static/images/store/icon-close-back-popup.svg" @click.prevent="closeModal" class="btn_close">
        <h1>{{ getTranslations.home_points_multiplier_header }}</h1>
        <img src="static/images/daily_bonus/photo-MidnightBonus.png" class="bonus_img">

        <div class="double_points_bg" v-if="counter">
          <h2>{{ getTranslations.home_points_multiplier_points }}</h2>
          <h3>{{ getTranslations.home_points_multiplier_duration }}</h3>
          <div class="store_countdown">
            <p v-if="counter"></p>
          </div>
        </div>
        <h4>{{ getTranslations.home_points_multiplier_between_part_1 }}
          {{ dateStart }} - {{ dateEnd }}
          {{ getTranslations.home_points_multiplier_between_part_2 }}{{ phaseBonusModalToBeDisplayed.multiplier }}</h4>
        <h5>{{ getTranslations.home_points_multiplier_play_now }}</h5>

        <button type="button" @click.prevent="playGameMethod">{{ getTranslations.home_points_multiplier_start_new_game
          }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
// midnight_bonus_popup.html
import { mapGetters, mapMutations, mapState } from 'vuex';
import Vue from 'vue';
import $ from 'jquery';

const moment = require('moment');

Vue.use(require('vue-moment'), {
  moment,
});

export default {
  name: 'bonus-multiplier',
  data() {
    return {
      showSearchModal: false,
      timer: 0,
      counter: '',
      dateStart: null,
      dateEnd: null,
    };
  },
  beforeDestroy() {
    this.storeModalForHomePage(null);
    this.updatePhaseBonusModalToBeDisplayed(null);
  },
  created() {
    moment.locale('EN');
    this.dateStart = moment(this.phaseBonusModalToBeDisplayed.start).format('hh:mm:ss');
    this.dateEnd = moment(this.phaseBonusModalToBeDisplayed.end).format('hh:mm:ss');
    const interval = 1000; // every 1 second
    let duration;
    // get time element
    // calculate difference between two times
    const eventTime = moment(this.phaseBonusModalToBeDisplayed.end);
    // loop to countdown every 1 second
    this.timer = setInterval(() => {
      // based on time set in user's computer time / OS
      const currentTime = moment(new Date());
      // get duration between two times
      duration = moment.duration(eventTime.diff(currentTime));
      // get updated duration
      duration = moment.duration(duration - interval, 'milliseconds');
      // if duration is >= 0
      if (currentTime.isAfter(eventTime)) {
        clearInterval(this.timer);
        // hide the countdown element
        this.counter = '';
        this.phaseBonusModalToBeDisplayed.active = false;
      } else {
        // otherwise, show the updated countdown
        this.counter = `${duration.hours()} : ${duration.minutes()} : ${duration.seconds()}`;
        $('.store_countdown p').html(this.counter);
      }
    }, interval);
  },
  methods: {
    ...mapMutations('common', [
      'storeModalForHomePage',
    ]),
    ...mapMutations('profile', [
      'updatePhaseBonusModalToBeDisplayed',
      'saveBonusDailyModal',
    ]),
    closeModal() {
      this.storeModalForHomePage(null);
      this.saveBonusDailyModal(null);
    },
    playGameMethod() {
      this.$router.push('home');
    },
  },
  computed: {
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
    ...mapState('profile', [
      'phaseBonusModalToBeDisplayed',
    ]),
  },
};
</script>



// WEBPACK FOOTER //
// src/components/home/modals/bonus_phases/PointsMultiplier.vue